// extracted by mini-css-extract-plugin
export default {"changeLevelButton":"ChangeLevelButton_changeLevelButton__Pg5uA"};